import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

/**
 * LockScreenCheck - Ensures locked screens can only access the lock screen route
 * This component completely blocks navigation to ANY other route, including login,
 * when the screen is locked.
 */
const LockScreenCheck = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const routes = all_routes;

  // Check if screen is locked
  const isScreenLocked = sessionStorage.getItem("isScreenLocked") === "true";

  // Use effect to block navigation attempts
  useEffect(() => {
    if (isScreenLocked && location.pathname !== routes.lockScreen) {
      navigate(routes.lockScreen, { replace: true });
    }
  }, [isScreenLocked, location.pathname, navigate, routes.lockScreen]);

  // If screen is locked and trying to access any page other than lock screen,
  // redirect to lock screen
  if (isScreenLocked && location.pathname !== routes.lockScreen) {
    return <Navigate to={routes.lockScreen} replace />;
  }

  // Otherwise, render the requested route
  return <Outlet />;
};

export default LockScreenCheck;
